import {RouterState, RouterStateModel as RouterStateOuterModel} from '@ngxs/router-plugin';
import { Selector } from '@ngxs/store';
import { RouterStateModel } from './router-state.model';
import {Params} from '@angular/router';

export class RouterSelectors {
  @Selector([RouterState])
  static data({ state }: RouterStateOuterModel<RouterStateModel>): any {
    return state?.data;
  }

  @Selector([RouterState])
  static params({ state }: RouterStateOuterModel<RouterStateModel>): Params | undefined {
    return state?.params;
  }

  @Selector([RouterState])
  static queryParams({ state }: RouterStateOuterModel<RouterStateModel>): Params | undefined {
    return state?.queryParams;
  }

  @Selector([RouterState])
  static url({ state }: RouterStateOuterModel<RouterStateModel>): string | undefined {
    return state?.url;
  }
}
